import { useTranslation } from 'react-i18next';

import Button from '../general/Button';
import { SupportConversation } from '../../api/support/types';
import { useSupportHours } from '../../api/support/useSupport';

interface SupportChatEscalationProps {
    conversation: SupportConversation | undefined;
    isBusy: boolean;
    onEscalate: () => void;
}

/**
 * Recours vers l'équipe sous le fil : bandeau « transmis », question restée sans réponse
 * (job de l'IA perdu), et lien discret toujours présent tant que l'IA répond.
 */
export default function SupportChatEscalation({ conversation, isBusy, onEscalate }: SupportChatEscalationProps) {
    const { t } = useTranslation('support');
    const { data: hours } = useSupportHours();
    const label = hours?.label;

    if (conversation?.status === 'waiting_human') {
        return <p className="bg-main-color-light px-3 py-2 text-xs text-main-color-dark">{label ? t('escalated_banner_hours', { label }) : t('escalated_banner')}</p>;
    }
    if (conversation?.status !== 'ai') return null;

    const lastMessage = conversation.messages?.[conversation.messages.length - 1];
    const isOrphan = !isBusy && !conversation.assistant_pending && lastMessage?.role === 'user';

    if (isOrphan) {
        return (
            <div role="status" className="flex items-center justify-between gap-2 bg-main-color-light px-3 py-2 text-xs text-main-color-dark">
                <span>{t('assistant_unavailable')}</span>
                <Button type="primary-outline" size="sm" elementType="button"
                    attributes={{ onClick: onEscalate }} text={t('talk_to_team')} />
            </div>
        );
    }

    return (
        <div className="flex flex-col items-end px-3 pt-1">
            <button type="button" onClick={onEscalate}
                className="text-xs text-text-color-light underline hover:text-primary-color">
                {t('talk_to_team')}
            </button>
            {label && <p className="text-xs text-text-color-light">{t('team_hours', { label })}</p>}
        </div>
    );
}
